import React from 'react'
import { Route, Routes } from 'react-router-dom';

// Js
import { GlobalContext } from '../../Global/GlobalContext';

// Components
import List from './List';
import Remove from './Remove';
import Update from './Update';
import Add from './Add';

const Deceaseds = () => {
    const {setHeaderData} = React.useContext(GlobalContext);

    React.useState(() => {
        setHeaderData("Falecidos", "Adicione, edite e remova os falecidos");
    })

    return (
        <Routes>
            <Route path="/" exact element={<List />} />
            <Route path="/adicionar" element={<Add />} />
            <Route path="/atualizar/:id" element={<Update />} />
            <Route path="/remover/:id" element={<Remove />} />
        </Routes>
    )    
}

export default Deceaseds
